export enum EffectDateType {
  PERMANENT = 'LONG_TERM',
  SEASONAL = 'CYCLICAL_TERM',
}
export const EffectDateTypeText = new Map([
  [EffectDateType.PERMANENT, '长期生效'],
  [EffectDateType.SEASONAL, '周期生效'],
]);

export enum AnchorLayerType {
  MOVE_ROUND = 'VOT_TNTA',
  ROAD_CLOSED = 'VOT_ROAD_CLOSURE',
  NO_PARKING = 'VOT_NO_PARKING',
  FOCUS_AREAS = 'ATTENTION_REGION_WARN',
  ATTRIBUTE_ANNOTATION = 'ATTRIBUTE_ANNOTATION',
  SPEED_LIMIT = 'SPEED_LIMIT',
  AIR_GROUND_GEOFENCE = 'AIR_GROUND_GEOFENCE',
  ROAD_TEST_FOCUS_AREA = 'ROAD_TEST_FOCUS_AREA',
  LD_ASSIST = 'LD_ASSIST',
  NAVIGATION = 'NAVIGATION',
  NO_HORN_ZONE = 'NO_HORN_ZONE',
}

export enum LightMapAssistType {
  BUFFER_ZONE = 'LD_BUFFER_ZONE',
  PARKING_ZONE = 'LD_PARKING_ZONE',
  WARNING_ZONE = 'LD_WARNING_ZONE',
}
export enum LayerIdEnum {
  TIANMAP_LAYER = 'TIANMAP_LAYER',
  TDTCVA_LAYER = 'TDTCVA_LAYER',
  WSM_LAYER = 'WSM_LAYER',
  ANCHOR_LAYER = 'ANCHOR_LAYER',
  SEARCHPOINT_LAYER = 'SEARCHPOINT_LAYER',
  INTER_LAYER = 'INTER_LAYER',
  BOUNDARY_LAYER = 'BOUNDARY_LAYER',
  STOPLINE_LAYER = 'STOPLINE_LAYER',
  GATE_LAYER = 'GATE_LAYER',
  OPENAREA_LAYER = 'OPENAREA_LAYER',
  ATTRIBUTE_MARK_LAYER = 'ATTRIBUTE_MARK_LAYER',
  LANE_LINE_LAYER = 'LANE_LINE_LAYER',
  ROUTE_PLAN_LAYER = 'ROUTE_PLAN_LAYER',
}
export const AnchorLayerText = new Map([
  [AnchorLayerType.MOVE_ROUND, '绕行障碍物'],
  [AnchorLayerType.ROAD_CLOSED, '封路障碍物'],
  [AnchorLayerType.NO_PARKING, '小区禁停区'],
  [AnchorLayerType.FOCUS_AREAS, '重点关注区'],
  [AnchorLayerType.ATTRIBUTE_ANNOTATION, '属性标注区'],
  [AnchorLayerType.SPEED_LIMIT, '道路限速区'],
  [AnchorLayerType.AIR_GROUND_GEOFENCE, '空地一体倾倒区域围栏'],
  [AnchorLayerType.ROAD_TEST_FOCUS_AREA, '路测关注区'],
  [AnchorLayerType.LD_ASSIST, '轻图测试'],
  [AnchorLayerType.NAVIGATION, '道路导航区'],
  [AnchorLayerType.NO_HORN_ZONE, '禁鸣区'],
]);

export const LightMapAssistTypeText = new Map([
  [LightMapAssistType.BUFFER_ZONE, '轻图缓冲区'],
  [LightMapAssistType.PARKING_ZONE, '轻图停车区'],
  [LightMapAssistType.WARNING_ZONE, '轻图危险区'],
]);

export const getAnchorLayerText = (type: AnchorLayerType, subType?: string): string | undefined => {
  if (type === AnchorLayerType.LD_ASSIST && subType) {
    return (
      LightMapAssistTypeText.get(subType as LightMapAssistType) ??
      AnchorLayerText.get(type)
    );
  }
  return AnchorLayerText.get(type);
};
export enum AttributeType {
  HANGING_BRANCH = 'HANGING_BRANCH',
  BUMPY_ROAD = 'BUMPY_ROAD',
  DRAIN_COVER = 'DRAIN_COVER',
  UPWARD_SLOPE = 'UPWARD_SLOPE',
  DOWNWARD_SLOPE = 'DOWNWARD_SLOPE',
  INVALID_GATE = 'INVALID_GATE',
  BARRIER_GATE = 'BARRIER_GATE',
  UNMANNED_STATION = 'UNMANNED_STATION', // 无人站
  INVALID_TRAFFIC_LIGHT = 'INVALID_TRAFFIC_LIGHT',
  FENCE = 'FENCE',
  STOP_FLAG = 'STOP_FLAG',
  PARK = 'PARK',
  BACKUP1 = 'BACKUP1',
  BACKUP2 = 'BACKUP2',
  INTERSECTION_LIGHT = 'INTERSECTION_LIGHT',
  INTERSECTION_PASS = 'INTERSECTION_PASS',
  INTERSECTION_TAKEOVER = 'INTERSECTION_TAKEOVER',
}
export const AttributeTypeText = new Map([
  [AttributeType.BUMPY_ROAD, '颠簸路面'],
  [AttributeType.DOWNWARD_SLOPE, '下坡路段'],
  [AttributeType.DRAIN_COVER, '排水井盖'],
  [AttributeType.HANGING_BRANCH, '下垂树枝'],
  [AttributeType.UPWARD_SLOPE, '上坡路段'],
  [AttributeType.INVALID_GATE, '无效大门'],
  [AttributeType.BARRIER_GATE, '过杆'],
  [AttributeType.UNMANNED_STATION, '无人站'],
  [AttributeType.INVALID_TRAFFIC_LIGHT, '无效红绿灯'],
  [AttributeType.FENCE, '栅栏'],
  [AttributeType.STOP_FLAG, '停车让行线'],
  [AttributeType.PARK, '园区'],
  [AttributeType.BACKUP1, '黑灯'],
  [AttributeType.BACKUP2, '黄闪灯'],
  [AttributeType.INTERSECTION_LIGHT, '路口看灯（轻图）'],
  [AttributeType.INTERSECTION_PASS, '路口通行（轻图）'],
  [AttributeType.INTERSECTION_TAKEOVER, '路口接管（轻图）'],
]);

export enum EffectTimeType {
  ALL_TIME = 'ALL_TIME',
  PERIOD_TIME = 'PERIOD_TIME',
}

export const EffectTimeTypeText = new Map([
  [EffectTimeType.ALL_TIME, '全天生效'],
  [EffectTimeType.PERIOD_TIME, '分时生效'],
]);

export enum EffectState {
  ENABLE = 'RS_INUSE',
  DISABLED = 'RS_DISCARDED',
}

export const EffectStateText = new Map([
  [EffectState.ENABLE, '启用'],
  [EffectState.DISABLED, '停用'],
]);

export const EnableBtnTitleMap = new Map([
  [EffectState.ENABLE, '停用'],
  [EffectState.DISABLED, '启用'],
]);

export enum EffectVehicleType {
  ALL_EFFECT = 'ALL_EFFECT',
  PART_EFFECT = 'PART_EFFECT',
  PART_UN_EFFECT = 'PART_EFFECTLESS',
}

export const EffectVehicleTypeText = new Map([
  [EffectVehicleType.ALL_EFFECT, '全部生效'],
  [EffectVehicleType.PART_EFFECT, '部分车辆生效'],
  [EffectVehicleType.PART_UN_EFFECT, '部分车辆不生效'],
]);

/** 生效车范围枚举（封路障碍物类型专用） */
export enum EffectiveMapType {
  LD_EFFECTIVE = 'LD_EFFECTIVE',
  HD_EFFECTIVE = 'HD_EFFECTIVE',
}

export const EffectiveMapTypeText = new Map([
  [EffectiveMapType.LD_EFFECTIVE, '轻图车有效'],
  [EffectiveMapType.HD_EFFECTIVE, '高精车有效'],
]);

export const WeekLimitText = new Map([
  ['MONDAY', '周一'],
  ['TUESDAY', '周二'],
  ['WEDNESDAY', '周三'],
  ['THURSDAY', '周四'],
  ['FRIDAY', '周五'],
  ['SATURDAY', '周六'],
  ['SUNDAY', '周日'],
]);

export enum PositionSelectType {
  position = 'position',
  station = 'station',
  stop = 'stop',
  vehicle = 'vehicle',
  latLag = 'latLag',
}

export const PositionSelectText = new Map([
  [PositionSelectType.position, '地理位置'],
  [PositionSelectType.station, '站点'],
  [PositionSelectType.stop, '停靠点'],
  [PositionSelectType.vehicle, '车号'],
  [PositionSelectType.latLag, '经纬度'],
]);

export enum PermissionButton {
  SPV_ORDER_DETAIL = 'spv_order_detail',
  SPV_CHECK_ORDER = 'spv_check_order',
  SPV_ORDER_OPERATIONS = 'spv_order_operations',
  SPV_ALARM_DRAWER = 'spv_alarm_drawer',
  SPV_VIDEO = 'spv_video',
  SPV_LOCAL_VIEW = 'spv_local_view',
  SPV_CONTROL_LIST = 'spv_control_list',
  SPV_JIRA_REPORT = 'spv_jira_report',
  SPV_ASSIST_JIRA_REPORT = 'spv_assist_jira_report',
  SPV_ISSUE_HANDLE = 'spv_issue_handle',
  VEHILCE_BASIC_INFO_DETAIL = 'vehicle_basic_info_detail',
  SPV_ISSUE_VIEW = 'spv_issue_view',
  SPV_ISSUE_REPORT = 'spv_issue_report',
  SPV_WORK_ORDER_COLUMN_ISSUE_REPORT = 'spv_work_order_column_issue_report',
  SPV_ADD_AREAS = 'spv_add_areas',
  SPV_DELETE_AREAS = 'spv_delete_areas',
  SPV_ENABLE_AREAS = 'spv_enable_areas',
  SPV_EDIT_RECORD = 'spv_edit_record',
  SPV_COMMAND_TERMINAL = 'spv_command_terminal',
  SPV_ADD_MANUAL_EVENT_BTN = 'spv_add_manual_event_btn',
  VEHICLE_INIT_PREVIEW_BTN = 'vehicle_init_info',
  SPV_ROUTE_PLAN = 'spv_route_plan',
}

export const CLSTAG = {
  AddAreas: 'realtime__1726816968981|23', // 新增动态地图
  CancelAddAreas: 'realtime__1726816968981|24', // 取消新增动态地图
  [LayerIdEnum.ANCHOR_LAYER]: 'realtime__1726816968981|25', // 动态地图_可视隐藏-动态地图
  [LayerIdEnum.BOUNDARY_LAYER]: 'realtime__1726816968981|26', // 动态地图_可视隐藏-车道边线
  [LayerIdEnum.WSM_LAYER]: 'realtime__1726816968981|27', // 动态地图_可视隐藏-车道中心线
  [LayerIdEnum.INTER_LAYER]: 'realtime__1726816968981|28', // 动态地图_可视隐藏-路口
  [LayerIdEnum.OPENAREA_LAYER]: 'realtime__1726816968981|29', // 动态地图_可视隐藏-开阔区域
  [LayerIdEnum.GATE_LAYER]: 'realtime__1726816968981|30', // 动态地图_可视隐藏-大门
  [LayerIdEnum.STOPLINE_LAYER]: 'realtime__1726816968981|31', // 动态地图_可视隐藏-停止线
  LegendExpandFold: 'realtime__1726816968981|32', // 动态地图_示意图展开收起
  SearchParam_TypeList: 'realtime__1726816968981|33', // 动态地图_筛选项-类型
  SearchParam_Operator: 'realtime__1726816968981|34', // 动态地图_筛选项-操作人
  SearchParam_Status: 'realtime__1726816968981|35', // 动态地图_筛选项-状态
  SearchParam_EffectDateType: 'realtime__1726816968981|36', // 动态地图_筛选项-生效类别
  SearchParam_Remark: 'realtime__1726816968981|37', // 动态地图_筛选项-备注
  SearchParam_EffectVehicleType: 'realtime__1726816968981|38', // 动态地图_筛选项-生效范围
  [AnchorLayerType.MOVE_ROUND]: 'realtime__1726816968981|39', // 动态地图_类型-绕行障碍物
  [AnchorLayerType.ROAD_CLOSED]: 'realtime__1726816968981|40', // 动态地图_类型-封路障碍物
  [AnchorLayerType.NO_PARKING]: 'realtime__1726816968981|41', // 动态地图_类型-小区禁停区
  [AnchorLayerType.FOCUS_AREAS]: 'realtime__1726816968981|42', // 动态地图_类型-重点关注区
  [EffectState.DISABLED]: 'realtime__1726816968981|43', // 动态地图_状态-停用
  [EffectState.ENABLE]: 'realtime__1726816968981|44', // 动态地图_状态-启用
  [EffectDateType.PERMANENT]: 'realtime__1726816968981|45', // 动态地图_状态-启用
  [EffectDateType.SEASONAL]: 'realtime__1726816968981|46', // 动态地图_状态-启用
  [EffectVehicleType.ALL_EFFECT]: 'realtime__1726816968981|47', // 动态地图_状态-启用
  [EffectVehicleType.PART_EFFECT]: 'realtime__1726816968981|48', // 动态地图_状态-启用
  [EffectVehicleType.PART_UN_EFFECT]: 'realtime__1726816968981|49', // 动态地图_状态-启用
  [AnchorLayerType.ROAD_TEST_FOCUS_AREA]: 'realtime__1726816968981|60', // 动态地图_类型-路测关注区
  OpenFoldRightDrawer: 'realtime__1726816968981|50', // 动态地图_右侧抽屉展开收起
  OperateCard: 'realtime__1727334823926|1', // 动态地图_表单卡片点击
  Reset: 'realtime__1727334823926|54', // 动态地图_重置
  Search: 'realtime__1727334823926|55', // 动态地图_搜索
  Edit: 'realtime__1727334823926|56', // 动态地图_编辑
  Delete: 'realtime__1727334823926|57', // 动态地图_删除
  Disable: 'realtime__1727334823926|58', // 动态地图_停用
  Enable: 'realtime__1727334823926|59', // 动态地图_启用
};
